import _toConsumableArray from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/inherits";
import _assertThisInitialized from "C:\\Users\\dcollier\\my-repos\\nfl-draft-pwa\\node_modules\\@babel\\runtime/helpers/esm/assertThisInitialized";
import React from 'react';
import Utils from '../utils/utils';
import Mixins from '../utils/mixins';
import F7Link from './link';
import __reactComponentDispatchEvent from '../runtime-helpers/react-component-dispatch-event.js';
import __reactComponentSlots from '../runtime-helpers/react-component-slots.js';
import __reactComponentSetProps from '../runtime-helpers/react-component-set-props.js';

var F7NavLeft =
/*#__PURE__*/
function (_React$Component) {
  _inherits(F7NavLeft, _React$Component);

  function F7NavLeft(props, context) {
    var _this;

    _classCallCheck(this, F7NavLeft);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(F7NavLeft).call(this, props, context));

    (function () {
      Utils.bindMethods(_assertThisInitialized(_assertThisInitialized(_this)), ['onBackClick']);
    })();

    return _this;
  }

  _createClass(F7NavLeft, [{
    key: "onBackClick",
    value: function onBackClick(event) {
      this.dispatchEvent('back-click backClick click:back clickBack', event);
    }
  }, {
    key: "render",
    value: function render() {
      var props = this.props;
      var backLink = props.backLink,
          backLinkUrl = props.backLinkUrl,
          backLinkForce = props.backLinkForce,
          backLinkShowText = props.backLinkShowText,
          sliding = props.sliding,
          className = props.className,
          style = props.style,
          id = props.id;
      var linkEl;
      var needBackLinkText = backLinkShowText;
      if (typeof needBackLinkText === 'undefined') needBackLinkText = !this.$theme.md;

      if (backLink) {
        var text = backLink !== true && needBackLinkText ? backLink : undefined;
        linkEl = React.createElement(F7Link, {
          href: backLinkUrl || '#',
          back: true,
          icon: 'icon-back',
          force: backLinkForce || undefined,
          className: !text ? 'icon-only' : undefined,
          text: text,
          onClick: this.onBackClick
        });
      }

      var classes = Utils.classNames(className, 'left', {
        sliding: sliding
      }, Mixins.colorClasses(props));
      var children = [];
      var slots = this.slots;

      if (slots && Object.keys(slots).length) {
        Object.keys(slots).forEach(function (key) {
          children.push.apply(children, _toConsumableArray(slots[key]));
        });
      }

      return React.createElement('div', {
        id: id,
        style: style,
        className: classes
      }, linkEl, children);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(events) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return __reactComponentDispatchEvent.apply(void 0, [this, events].concat(args));
    }
  }, {
    key: "slots",
    get: function get() {
      return __reactComponentSlots(this.props);
    }
  }]);

  return F7NavLeft;
}(React.Component);

__reactComponentSetProps(F7NavLeft, Object.assign({
  id: [String, Number],
  className: String,
  style: Object,
  backLink: [Boolean, String],
  backLinkUrl: String,
  backLinkForce: Boolean,
  backLinkShowText: {
    type: Boolean,
    default: undefined
  },
  sliding: Boolean
}, Mixins.colorProps));

F7NavLeft.displayName = 'f7-nav-left';
export default F7NavLeft;